import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faHistory } from "@fortawesome/free-solid-svg-icons"

export const History = (props) => {
  return <FontAwesomeIcon faIcon={faHistory} {...props} />
}
